import { useMemo } from 'react'
import { DateTime } from 'luxon'
import cn from 'classnames'

import CoinButton from '@components/CoinButton'
import { PromotionBuyAllEnum } from '@interfaces/PromotionTypeEnum'
import { promotionDate } from '@lib/promotion/utils'
import { BuyAllPromotionProps } from './interface'

export function BuyAllPromotion({
  data,
  totalPrice,
  isOwner,
  isDrawer,
  isAuthenticated,
  handleBuyAllPromotion,
}: BuyAllPromotionProps) {
  const hidePromotion = useMemo(() => {
    if (data) {
      const now = DateTime.now().valueOf()
      const end = DateTime.fromISO(data.endDate).valueOf()
      const start = DateTime.fromISO(data.startDate).valueOf()
      return now > end || now < start
    }

    return true
  }, [data])

  function discount() {
    const discountType =
      data?.discountType === PromotionBuyAllEnum.PERCENTAGE ? '%' : ' เหรียญ'
    const value = data?.discountValue || 0
    return `${value}${discountType}`
  }

  if (!data || hidePromotion || (isAuthenticated && totalPrice <= 0))
    return <></>

  return (
    <div
      className={cn('mobile:px-[20px] font-medium font-mitr', {
        'mt-[40px] mb-[30px]': !isDrawer,
        'my-6': isDrawer,
      })}
    >
      <div
        className={cn(
          'flex mobile:flex-col flex-wrap mobile:gap-y-[9px] items-center justify-between min-h-[78px] py-[20px] px-[40px] mobile:px-[35px] bg-red text-white',
          {
            'rounded-lg': !isDrawer,
            'mobile:rounded-lg': isDrawer,
          }
        )}
      >
        <div
          className={cn('desktop:flex mobile:text-center', {
            'desktop:space-x-[5px]': !isDrawer,
            'desktop:flex-col': isDrawer,
          })}
        >
          <div
            className={cn({
              'text-[24px] mobile:text-[20px]': !isDrawer,
              'text-[18px] mobile:text-[16px]': isDrawer,
            })}
          >
            ซื้อเหมา ลด {discount()}{' '}
          </div>

          <div
            className={cn('font-light', {
              'text-[24px] mobile:text-[12px]': !isDrawer,
              'text-[18px] mobile:text-[12px]': isDrawer,
            })}
          >
            (
            {promotionDate(
              data.startDate,
              data.endDate,
              'ตั้งแต่',
              true,
              false
            )}
            )
          </div>
        </div>

        {!isOwner && (
          <CoinButton
            type='button'
            onClick={handleBuyAllPromotion}
            className='desktop:min-w-[280px] mobile:w-full'
            secondClassName='text-xl h-[40px]'
            data-test='buy-all-chapter'
            size={40}
          >
            <span className='line-through pr-2'>
              {data.summaryPriceBeforeDiscount.toLocaleString()}
            </span>
            <span>{`${data.afterDiscountPrice.toLocaleString()} เหรียญ`}</span>
          </CoinButton>
        )}
        <div
          className={cn('font-light w-full', {
            'text-[16px] mobile:text-[12px]': !isDrawer,
            'text-[14px] mobile:text-[12px]': isDrawer,
          })}
        >
          *ลดจากราคาปกติของทุกตอน รวมตอนที่เคยซื้อไปแล้ว
        </div>
      </div>
    </div>
  )
}
